import { TrendingUp, TrendingDown } from 'lucide-react';

/**
 * RankDeltaBadge — tiny ▲N (green) / ▼N (red) chip showing how many places
 * a team moved since the user's LAST visit to this surface. Renders nothing
 * when there's no change (or no prior snapshot). `delta > 0` => moved up.
 */
export function RankDeltaBadge({ delta, className = '', testid }) {
  if (!delta || delta === 0) return null;
  const up = delta > 0;
  const n = Math.abs(delta);
  return (
    <span
      className={`inline-flex items-center gap-0.5 text-[9px] font-bold tabular-nums leading-none ${
        up ? 'text-[hsl(var(--positive-text))]' : 'text-red-600 dark:text-red-400'
      } ${className}`}
      data-testid={testid}
      title={up ? `Up ${n} since your last visit` : `Down ${n} since your last visit`}
    >
      {up ? <TrendingUp className="h-2.5 w-2.5" /> : <TrendingDown className="h-2.5 w-2.5" />}
      {n}
      <span className="sr-only">{up ? `up ${n} places since your last visit` : `down ${n} places since your last visit`}</span>
    </span>
  );
}

export default RankDeltaBadge;
